<template>
  <view class="content">
    <u--form ref="uForm"   :model="form"  labelPosition="left" labelWidth="90">
      <view class="title">期望入驻信息</view>
      <view class="container">
        <u-form-item   label="期望办公地址" prop="address" @click="showAddress = true; " labelWidth="130">
          <u--input v-model="form.address" border="none" disabled disabledColor="#ffffff" placeholder="请选择期望办公地址"></u--input>
          <u-icon slot="right" name="arrow-right"></u-icon>
        </u-form-item>
        <u-form-item   label="期望入驻开始时间" prop="expectBeginTime" @click="showExpectBeginTime = true; " labelWidth="130">
          <u--input v-model="form.expectBeginTime" border="none" disabled disabledColor="#ffffff" placeholder="请选择期望入驻开始时间"></u--input>
          <u-icon slot="right" name="arrow-right"></u-icon>
        </u-form-item>
        <u-form-item   label="期望入驻结束时间" prop="expectEndTime" @click="showExpectEndTime = true; " labelWidth="130">
          <u--input v-model="form.expectEndTime" border="none" disabled disabledColor="#ffffff" placeholder="请选择期望入驻结束时间"></u--input>
          <u-icon slot="right" name="arrow-right"></u-icon>
        </u-form-item>
      </view>
      <view class="title">入驻公司信息</view>
      <view class="container">
        <u-form-item  borderBottom label="公司名称" prop="deptName">
          <u--input
              v-model="form.deptName" placeholder="请输入公司名称"
              border="none"
          ></u--input>
        </u-form-item>
        <u-form-item  borderBottom label="统一社会信用代码" prop="creditCode" labelWidth="130">
          <u--input
              v-model="form.creditCode"  placeholder="请输入统一社会信用代码"
              border="none"
          ></u--input>
        </u-form-item>
        <u-form-item  borderBottom label="公司类型" prop="companyType">
          <u--input
              v-model="form.companyType"  placeholder="请输入公司类型"
              border="none"
          ></u--input>
        </u-form-item>
        <u-form-item  borderBottom label="注册资本" prop="money">
          <u--input
              v-model="form.money" placeholder="请输入注册资本"
              border="none"
          ></u--input>
        </u-form-item>
        <u-form-item   label="主要营业范围" prop="businessScope"  labelWidth="130">
          <u--input
              v-model="form.businessScope" placeholder="请输入主要营业范围"
              border="none"
          ></u--input>
        </u-form-item>
      </view>

      <view class="title">联系人信息</view>
      <view class="container">
        <u-form-item  borderBottom label="负责人" prop="leader">
          <u--input
              v-model="form.leader"  placeholder="请输入负责人姓名"
              border="none"
          ></u--input>
        </u-form-item>
        <u-form-item  borderBottom label="联系电话" prop="phone" >
          <u--input
              v-model="form.phone"  placeholder="请输入联系电话"
              border="none"
          ></u--input>
        </u-form-item>

        <u-form-item   label="邮箱" prop="email">
          <u--input
              v-model="form.email" placeholder="请输入邮箱"
              border="none"
          ></u--input>
        </u-form-item>
      </view>
      <view class="title">营业执照附件</view>
      <view class="container" style="padding-top: 10px;padding-bottom: 0">
        <u-upload
            :fileList="fileList1"
            @afterRead="afterRead"
            @delete="deletePic"
            name="1"
            multiple
            :maxCount="10"
        ></u-upload>
      </view>
    </u--form>
    <view style="margin-top: 50px;margin-bottom: 50px">
      <u-button @click="submit" shape="circle" type="primary">提交</u-button>
    </view>
    <u-picker :show="showAddress" ref="uPicker" :columns="columns" keyName="name" @confirm="confirm" @change="changeHandler" @cancel="showAddress = false"></u-picker>
    <u-calendar :show="showExpectBeginTime" mode="single" @confirm="confirmExpectBeginTime" @cancel="showExpectBeginTime = false"></u-calendar>
    <u-calendar :show="showExpectEndTime" mode="single" monthNum="120" @confirm="confirmExpectEndTime" @cancel="showExpectEndTime = false"></u-calendar>
    <u-modal :show="show" title="温馨提示" content='提交入驻申请成功!!!会有工作人员打电话给您，请注意接听' @confirm="confirmShow"></u-modal>
  </view>
</template>

<script>
import {getBuilding,getUnitList} from "@/common/api";
import config from "@/config";
import {approval} from "../../common/api";

export default {
  name: "index",
  data() {
    return {
      show: false,
      showAddress: false,
      showExpectBeginTime: false,
      showExpectEndTime: false,
      columns:[],
      form:{
        buildingId:undefined,
        buildingName:undefined,
        address:'',
        unitId:undefined,
        unitName:undefined,
        money:undefined,
        companyType:undefined,
        filePath:undefined,
        businessScope:undefined,
        creditCode:undefined,
        email:undefined,
        phone:undefined,
        leader:undefined,
        deptName:undefined,
        openId:undefined,
        expectBeginTime:undefined,
        expectEndTime:undefined,
      },
      rules: {
        address: [{required: true, message: '请选择期望入驻办公地址', trigger: ['blur', 'change']}],
        expectBeginTime: [{required: true, message: '请选择期望入驻开始时间', trigger: ['blur', 'change']}],
        expectEndTime: [{required: true, message: '请选择期望入驻结束时间', trigger: ['blur', 'change']}],
        deptName: [{required: true, message: '请输入公司名称', trigger: ['blur', 'change']}],
        creditCode: [{required: true, message: '请输入统一社会信用代码', trigger: ['blur', 'change']}],
        leader: [{required: true, message: '请输入负责人', trigger: ['blur', 'change']}],
        phone: [{required: true, message: '请输入联系电话', trigger: ['blur', 'change']}],
      },
      fileList1: [],
    }
  },

  methods: {
    getBuildingList(){
      getBuilding().then(res=>{
        this.columns[0] = res;
        this.$forceUpdate();
        this.getUnits(res[0].id)
      })
    },
    getUnits(id){
      const picker = this.$refs.uPicker
      getUnitList(id).then(res=>{
        console.log(res)
        picker.setColumnValues(1, res)
      })
    },
    changeHandler(e){
      const {
        columnIndex, // 第几列表滚动
        index, //滚动到第几行
        // 微信小程序无法将picker实例传出来，只能通过ref操作
        picker = this.$refs.uPicker
      } = e
      let id = this.columns[columnIndex][index].id;
      if (columnIndex === 0) {
        this.getUnits(id);
      }
    },
    confirm(e){
      let checkValue = e.value;
      if (checkValue.length === 2){
        this.form.buildingId = checkValue[0].id;
        this.form.buildingName = checkValue[0].name;
        if (checkValue[1]){
          this.form.unitId = checkValue[1].id;
          this.form.unitName = checkValue[1].name;
          this.form.address = this.form.buildingName + '-'+ this.form.unitName;
          this.showAddress  = false;
        }
      }
    },
    confirmExpectBeginTime(e){
      this.form.expectBeginTime = e[0];
      this.showExpectBeginTime = false;
    },
    confirmExpectEndTime(e){
      this.form.expectEndTime = e[0];
      this.showExpectEndTime = false;
    },
    // 删除图片
    deletePic(event) {
      this[`fileList${event.name}`].splice(event.index, 1)
    },
    // 新增图片
    async afterRead(event) {
      // 当设置 multiple 为 true 时, file 为数组格式，否则为对象格式
      let lists = [].concat(event.file)
      let fileListLen = this[`fileList${event.name}`].length
      lists.map((item) => {
        this[`fileList${event.name}`].push({
          ...item,
          status: 'uploading',
          message: '上传中'
        })
      })
      for (let i = 0; i < lists.length; i++) {
        const result = await this.uploadFilePromise(lists[i].url)
        let item = this[`fileList${event.name}`][fileListLen]
        this[`fileList${event.name}`].splice(fileListLen, 1, Object.assign(item, {
          status: 'success',
          message: '',
          url: result
        }))
        fileListLen++
      }
    },
    uploadFilePromise(url) {
      return new Promise((resolve, reject) => {
        let a = uni.uploadFile({
          url: config.host+'/smart/common/upload', // 仅为示例，非真实的接口地址
          filePath: url,
          name: 'file',
          success: (res) => {
            setTimeout(() => {
              resolve(res.data.fileName)
            }, 1000)
          }
        });
      })
    },

    submit(){
      this.$refs.uForm.validate().then(res => {
        approval(this.form).then(res=>{
          this.show = true;
        })
      })
    },
    confirmShow(){
      uni.switchTab({
        url: '/pages/index/index',
      });
    }
  },
  onLoad(){
    uni.setNavigationBarTitle({ title: '企业入驻申请',})
    this.getBuildingList();
  },

}
</script>

<style lang="scss" scoped>
@import "@/common/formCommon";
</style>
